"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _icons = require("../assets/icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AlertBox = exports.AlertBox = function AlertBox(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    isVisible = props.isVisible,
    title = props.title,
    message = props.message;
  if (!isVisible) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-start py-4 px-6 bg-red-100 rounded ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_icons.InfoIcon, {
    fillColor: "red"
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-base font-bold ml-2"
  }, title)), /*#__PURE__*/_react["default"].createElement("p", {
    className: "mt-2 ml-6"
  }, message));
};